import script from "./JournalContents.vue?vue&type=script&setup=true&lang=js"
export * from "./JournalContents.vue?vue&type=script&setup=true&lang=js"

import "./JournalContents.vue?vue&type=style&index=0&id=47ef5100&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47ef5100"]])

export default __exports__